module.exports = __webpack_public_path__ + "img/FixedTime.e10211c8.svg";